import { InjectionToken } from "@angular/core";
import { ICreateAppVersionModalService } from "./i-create-app-version-modal.service";

export const createAppVersionModalServiceInjectionToken: InjectionToken<ICreateAppVersionModalService> = new InjectionToken<ICreateAppVersionModalService>( "digital-signage.developer-dashboard.dashboard-web.CreateAppVersionModalService" );
